import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Container } from 'reactstrap';
import s from './SmallFooter.module.scss';

function SmallFooter(props) {
  const { links, intl } = props;
  const { locale } = intl;

  const date = new Date();
  const currentYear = date.getFullYear();

  const renderedLinks = links.map((link) => (
    <a
      key={link.i18n}
      className={s.link}
      id={`__test-link_${link.i18n}`}
      href={link.targets[locale]}
    >
      <FormattedMessage id={link.i18n} />
    </a>
  ));

  return (
    <div className={s.smallFooter}>
      <Container>
        <div className={s.footerContent}>
          <div className={s.copyright}>
            © VERBUND Energy4Business GmbH {currentYear}
          </div>
          <div className={s.linksWrapper}>{renderedLinks}</div>
        </div>
      </Container>
    </div>
  );
}

SmallFooter.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      targets: PropTypes.object.isRequired,
      i18n: PropTypes.string.isRequired,
    })
  ).isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default injectIntl(SmallFooter);
